export const ITEMS_TO_SHOW = 6;
